import React from 'react';

import styles from "../styles/entity-mega-header-module.module.scss";
import classNames from "classnames";
import {NavigationTabsModuleAsync} from "../../../../../modules/navigation-tabs-module/components/navigation-tabs-module.async";

export const EntityMegaHeaderModuleNavigationBar = ({entity, tabsContext}) => {
  return (
    <div className={classNames(styles.navigation_bar)}>
      {
        entity ? <NavigationTabsModuleAsync entity={entity} context={tabsContext}/> : null
      }
    </div>
  )
};
